enum formTypes {
  Form_Has_value = "Form_Has_value",
}

export default formTypes;

